module.exports = __webpack_public_path__ + "media/images/undraw/push_notifications-071bfa9f90c769935f0c0a8993ce2614.png";